// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class RedemptionListRequestModel {
    static getAttributeTypeMap() {
        return RedemptionListRequestModel.attributeTypeMap;
    }
}
RedemptionListRequestModel.discriminator = undefined;
RedemptionListRequestModel.additionalProperties = false;
RedemptionListRequestModel.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "dateOfService",
        "baseName": "dateOfService",
        "type": "string"
    },
];
//# sourceMappingURL=redemptionListRequestModel.js.map